<form class="needs-validation">
  <ix-input (keydown)="onKeyDown($event)"
            [class.ix-invalid]="invalidUUID"
            [disabled]="loading"
            [invalidText]="'overview.search.invalid_pass_id' | translate"
            [label]="'overview.search.battery_passport_id' | translate"
            class="w-100"
            #searchInput
            id="batterySearchTerm"
            placeholder="{{ 'overview.search.search_placeholder' | translate }}"
            type="text"
  >
    <ix-icon name="search" size="16" slot="start"/>
    @if (loading) {
      <ix-spinner slot="end" size="x-small"/>
    } @else if (searchInput.value) {
      <ix-icon-button
        slot="end"
        (click)="invalidUUID = false; searchInput.value='';"
        id="clear-button"
        icon="clear"
        onkeypress=""
        size="16"
        variant="subtle-tertiary"/>
    }
  </ix-input>
</form>
